import React, { createContext, useContext, useMemo, useState } from "react";

const Ctx = createContext(null);

export const DATE_PRESETS = [
  { id: "this_month", label: "This month" },
  { id: "prev_month", label: "Previous month" },
  { id: "last_year", label: "Last year" },
  { id: "30d", label: "Last 30 days" },
  { id: "90d", label: "Last 90 days" },
  { id: "180d", label: "Last 6 months" },
  { id: "365d", label: "Last 12 months" },
  { id: "all", label: "All time" },
];

const iso = (d) => d.toISOString().slice(0, 10);

function rangeFor(preset) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  switch (preset) {
    case "this_month":
      return { start: iso(new Date(y, m, 1)), end: iso(now) };
    case "prev_month":
      return { start: iso(new Date(y, m - 1, 1)), end: iso(new Date(y, m, 0)) };
    case "last_year":
      return { start: `${y - 1}-01-01`, end: `${y - 1}-12-31` };
    case "30d":
    case "90d":
    case "180d":
    case "365d": {
      const days = parseInt(preset, 10);
      const s = new Date();
      s.setDate(s.getDate() - days);
      return { start: iso(s), end: iso(now) };
    }
    default:
      return { start: "", end: "" };
  }
}

export function DateRangeProvider({ children }) {
  const [preset, setPreset] = useState("all");
  const { start, end } = useMemo(() => rangeFor(preset), [preset]);
  return (
    <Ctx.Provider value={{ preset, setPreset, start, end, presets: DATE_PRESETS }}>
      {children}
    </Ctx.Provider>
  );
}

export const useDateRange = () => useContext(Ctx);
